import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux"
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Link } from "react-router-dom";
import { marketingListActions } from "../../store/marketingListStore"
import { Translate } from "react-localize-redux";
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import Message from "../common/message";
import ModalInner from '../layoutItems/modalInner';

class TemplatesPopup extends Component {
    state = {
        name: '',
        saved: false
    }

    render() {
        return (
            <ModalInner close={this.props.close} title={this.props.translate("MarketingList.Results.Button.SaveSearch")}>
                <div>
                    {!this.state.saved && <>
                        <div style={{ padding: "1em 0.25em" }}>
                            <Translate id='MarketingList.TemplatesPopup.EnterSearchName' />

                        </div>
                        <div className="columns">
                            <div className="column">
                                <div className="field bb-field">
                                    <div className="control">
                                        <div className="columns">
                                            <div className="column bb-input-label-column is-one-third">
                                                <div className="vertically-centered">
                                                    <span><Translate id="MarketingList.TemplatesPopup.SearchName" /></span>
                                                </div>
                                            </div>
                                            <div className="column bb-input-column is-two-thirds">
                                                <input type="text" id="name" className="input form-control" maxLength="50"
                                                    value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-inner-buttons">
                            <button type="button" onClick={this.props.close} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id='Common.Button.Cancel' /></button>
                            <button type="button" onClick={this.onSave} disabled={this.state.name === '' || isNullOrUndefined(this.state.name)} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id='Common.Button.Save' /></button>
                        </div>
                    </>}
                    {this.state.saved && <Message type='success' message={
                        <Translate id='MarketingList.TemplatesPopup.Saved' options={{ renderInnerHtml: true }}
                            data={{
                                templates:
                                    <Link to={`templates`} key={'MarketingList.Templates'} className={classnames('link-internal', { 'is-normal': localStorage.locales_url_format === 'normal' })} style={{ display: 'inline-flex' }}>
                                        <Translate id='MarketingList.Templates' />
                                    </Link>
                            }} />
                    } shadowed={true} />}
                </div>
            </ModalInner>
        )
    }

    onSave = () => {
        this.props.createTemplateFromRequest(this.props.data, this.state.name, this.setState({ saved: true }));
    }
}

export default withLocalize(withRouter(connect(
    state => { return { marketingList: state.marketingList } },
    dispatch => bindActionCreators(marketingListActions, dispatch)
)(TemplatesPopup)));